<template>
    <div>
        <bv-top></bv-top>
        <van-notice-bar left-icon="volume-o"
                        text="本页面只展示已开放在线查询的小区房屋信息"
                        v-if="isShowNotice === 'Y'"
        />
        <van-swipe width="100%" :loop="false" :key="house.houseNo" v-for="house in houseList">
            <van-swipe-item>
                <card-detail>
                    <template #title>
                        <van-cell class="addressCell" >{{house.address}}</van-cell>
                    </template>
                    <template slot="content">
                        <van-row type="flex" justify="space-between" class="content">
                            <van-col span="12" class="content-left">
                                {{house.constructAreaFormat}}m²/{{house.houseProp}}
                            </van-col>
                            <van-col span="12" class="content-left">
                                余额：{{house.balanceFormat}}元
                            </van-col>
                        </van-row>
                        <van-row type="flex" justify="space-between" class="content">
                            <van-col span="19" class="content-left">
                                姓名：{{house.ownerName}}
                            </van-col>
                            <van-col span="5" style="color: #27B1F9" @click="houseInfoDetail(house.houseNo)">
                                房屋详情>>
                            </van-col>
                        </van-row>
                    </template>
                </card-detail>
            </van-swipe-item>
        </van-swipe>
        <van-notice-bar left-icon="volume-o"
                        text="尊敬的用户，维修资金系统没有查询到您名下的房屋信息。"
                        v-if="houseList.length === 0 && isShowNotice === 'N'"
        />
    </div>
</template>

<script>
    import { Swipe, SwipeItem, NoticeBar } from 'vant';
    import CardDetail from '@/components/card-detail.vue'
    import Top from '@/views/components/Top'
    import {myHouseList} from '@/api/maintainFund/maintainFund'
    import '@/styles/maintainFund.scss'

    export default {
        name: "HouseList",
        data() {
            return {
                rightImg: require('@/assets/listRight.png'),
                houseNo: '',
                houseList: [],
                //下拉刷新
                isLoading: false,
                //数据是否全部加载完毕
                finished: false,
                error: false,
                house:{},
                isShowNotice:'N'
            }
        },
        components: {
            BvTop: Top,
            VanSwipe: Swipe,
            VanSwipeItem: SwipeItem,
            VanNoticeBar: NoticeBar,
            CardDetail
        },
        mounted() {
            myHouseList().then(res => {
                this.houseList = res.data.houseInfoList;
                this.isShowNotice = res.data.isShowNotice;
                // 数据全部加载完成
                if (this.currentPage === this.pageCount || this.pageCount === 0) {
                    this.finished = true;
                }
                this.$toast.clear();
            });
        },
        methods: {
            // //下拉刷新
            // onRefresh() {
            //     myHouseList().then(res => {
            //         this.houseList = res.data.list;
            //         if (this.currentPage === this.pageCount || this.pageCount === 0) {
            //             this.finished = true;
            //         } else {
            //             this.finished = false;
            //         }
            //         this.isLoading = false;
            //     });
            // },
            houseInfoDetail(houseId) {
                this.$router.push({path: '/maintainFund/houseListInfo', query: {label: '房屋详细信息', param: houseId}})
            },
        }
    }
</script>

<style lang="scss" scoped>
    .content {
        padding: 10px 0;
    }
    .content-left {
        color: #999;
    }
    .addressCell {
        background-color: #eacd76;
        background-image: linear-gradient(90deg, #bbf0f9 20%, #fbfbfb 99%);
    }
</style>
